module.exports = __webpack_public_path__ + "img/serve3.3a1b0875.png";